<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <!-- Header -->
        <layout-header />
        <!-- /Header -->

        <!-- Page Content -->
        <div class="content container">
            <div class="px-3">
                <div class="row">
                    <div class="col-lg-3 d-lg-block d-none theiaStickySidebar mb-3">
                        <div class="stickyside">
                            <div class="rounded-xl d-none d-lg-block shadow-sm p-2"><vendor-sidebar></vendor-sidebar></div>
                        </div>
                    </div>

                    <div class="col-lg-9 col-md-12 mb-5">
                        <div class="border-bottom mb-3">
                            <h2>Caisse</h2>
                        </div>

                        <div class="row mb-2">
                            <div class="col-md-3 col-6 mb-2 px-md-3" v-for="(card, index) in cardsDisplay" :class="{'pr-2': index % 2 == 0, 'pl-2': index % 2 != 0 }" :key="index">
                                <div class="card border-left-primary shadow h-100 px-1 py-2" style="margin-bottom: 0;">
                                    <div class="p-2 h-100">
                                        <div class="d-flex justify-content-between align-items-center h-100">
                                            <div class="mr-1">
                                                <div class="text-xs font-weight-bold text-uppercase mb-1" :class="card.color">{{ card.label }}</div>
                                                <div class="h5 mb-0 font-weight-bold text-gray-800">{{ card.aggregation }}<sup v-if="card.icon == 'payments'">DT</sup></div>
                                            </div>
                                            <div class="">
                                                <span class="material-symbols-outlined h1 mb-0">{{ card.icon }}</span>
                                                <!-- <i class="fas fa-calendar fa-2x text-gray-300"></i> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="tab-content py-3">
                            <div class="tab-pane fade show active">
                                <div class="d-flex justify-content-center align-items-center flex-wrap">
                                    <div v-if="currentUser.role === 'admin'" class="card-label mb-1 mx-1" style="min-width: 185px;">
                                        <label>Établissement</label>
                                        <v-select :options="filteredEstablishments" v-model="selectedEstablishment" label="business_name" 
                                            :reduce="option => String(option.id)" class="custom-vs form-control input text-xs"
                                            placeholder="Rechercher établissement..."/>
                                    </div>
                                    <div class="card-label mb-1 mx-1">
                                        <label>Statut Paiement</label>
                                        <select class="custom-select text-xs pr-3" v-model="selectedPaymentStatus" style="min-width: 135px;">
                                            <option value="all">Tous</option>
                                            <option value="paid">Payé</option>
                                            <option value="unpaid">Non Payé</option>
                                            <option value="partially_paid">Paie. Partiel</option>
                                        </select>
                                    </div>
                                </div>
                                <div v-if="settlements.length == 0" class="text-center">
                                    <span class="text-sm d-block mb-4 mt-2">Aucune réservation.</span>
                                </div>
                                <div v-else-if="filteredSettlements.length == 0" class="text-center">
                                    <span class="text-sm d-block mb-4 mt-2">Aucun résultat pour ce filtre.</span>
                                </div>
                                <div v-else class="mb-5">
                                    <div class="table-responsive text-xs p-0 py-2">
                                        <table class="table table-hover table-center mb-0">
                                            <thead class="bg-light">
                                                <tr>
                                                    <th>Éts.</th>
                                                    <th>Période</th>
                                                    <th>Nbre Réserv.</th>
                                                    <th>Total à Payer</th>
                                                    <th>À</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item in paginatedData" :key="item.id" class="position-relative">
                                                    <td style="min-width: 140px;">
                                                        <div class="d-flex justify-content-start mb-1">
                                                            <img :src="item.establishment.logo_url || defaultLogo" width="40px" height="40px" class="bg-white rounded-lg p-1 d-inline-block mr-2">
                                                            <div class="d-flex flex-column justify-content-center">
                                                                <span>{{ item.establishment.business_name }}</span>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <a class="stretched-link" href="javascript:void(0)" @click="openBookingsModal(item)"
                                                            data-toggle="modal" data-target="#bookingsModal"></a>
                                                        <span class="d-block">{{ String(item.month).padStart(2, '0') }}-{{ item.year }}</span>
                                                        <span class="badge btn btn-rounded px-2 py-1 mt-1" :class="settlementStatuses[item.status]?.class">
                                                            {{ settlementStatuses[item.status]?.label }}
                                                        </span>
                                                    </td>
                                                    <td>{{ item.count_bookings }}</td>
                                                    <td>{{ item.total_to_pay.toFixed(3) }}<sup>DT</sup></td>
                                                    <td>6v6</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <!-- PAGINATION -->
                                    <nav class="mt-3">
                                        <ul class="pagination justify-content-center">
                                            <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                                <button class="page-link text-dark" @click="goToPage(currentPage - 1)">
                                                    <span class="material-symbols-outlined text-sm">arrow_back</span>
                                                </button>
                                            </li>
                                            <li class="page-item">
                                                <select class="page-link text-dark text-xs h-100" v-model="currentPage" @change="goToPage(Number(currentPage))">
                                                    <option v-for="page in totalPages" :key="page" :value="page">
                                                        Page {{ page }}
                                                    </option>
                                                </select>
                                            </li>
                                            <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                                                <button class="page-link text-dark" @click="goToPage(currentPage + 1)">
                                                    <span class="material-symbols-outlined text-sm">arrow_forward</span>
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="bookingsModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable" style="min-width: 75%;">
            <div class="modal-content">
                <div class="modal-header">
                    <h5>Réservations de <b>{{ selectedSettlement.establishment?.business_name }}</b> ({{ String(selectedSettlement.month).padStart(2, '0') }}-{{ selectedSettlement.year }})</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span class="material-symbols-outlined">close</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="modal-body p-0 mb-4" style="min-height: 40vh;">
                        <div v-if="currentModalView == 'bookings'">
                            <div v-if="bookings.length > 0">
                                <div class="row w-100 mx-auto mt-2 mb-3" v-if="currentUser.role === 'owner'">
                                    <div class="col-md-4">
                                        <div class="form-group card-label">
                                            <label>Filtrer par Terrain</label>
                                            <select class="form-control custom-select text-sm" v-model="selectedFacility" @change="updateSettlementCards">
                                                <option value="all">Tous les terrains</option>
                                                <option v-for="facility in facilities" :key="facility.id" :value="facility.id">
                                                    {{ facility.name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="row w-100 mx-auto mt-2">
                                    <div class="col-12 col-md-4 mb-2 px-1" v-for="(card, index) in settlementCards" :class="{'pl-md-1 pr-md-3': index === 0, 'px-md-3': index === 1, 'pr-md-1 pl-md-3': index === 2}" :key="index">
                                        <div class="card border-left-primary shadow h-100 px-1 py-2" style="margin-bottom: 0;">
                                            <div class="p-2 h-100">
                                                <div class="d-flex justify-content-between align-items-center h-100">
                                                    <div class="mr-1">
                                                        <div class="text-xs font-weight-bold text-uppercase mb-1" :class="card.color">{{ card.label }}</div>
                                                        <div class="h5 mb-0 font-weight-bold text-gray-800">{{ card.aggregation }}<sup v-if="card.icon == 'payments'">DT</sup></div>
                                                    </div>
                                                    <div class="">
                                                        <span class="material-symbols-outlined h1 mb-0">{{ card.icon }}</span>
                                                        <!-- <i class="fas fa-calendar fa-2x text-gray-300"></i> -->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive text-xs p-0 py-2">
                                    <table class="table table-hover table-center mb-0">
                                        <thead class="bg-light">
                                            <tr>
                                                <th>Terrain/Pour le/Par</th>
                                                <th>Statut</th>
                                                <th>Moyen Paie./Montant</th>
                                                <th>Créée le</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in paginatedBookingsData" :key="item.id">
                                                <td style="min-width: 165px;">
                                                    <div class="d-flex justify-content-start mb-1">
                                                        <img :src="selectedSettlement.establishment.logo_url || defaultLogo" width="40px" height="40px" class="bg-white rounded-lg p-1 d-inline-block mr-2">
                                                        <div class="d-flex flex-column justify-content-center">
                                                            <span>Terrain {{ item.slot.facility.name }}</span>
                                                            <span class="text-muted">{{ selectedSettlement.establishment.business_name }}</span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        Pour le <b>{{ formatDateTime(item.start_time).date }}</b>
                                                        <span class="d-block text-muted">
                                                            {{ formatDateTime(item.start_time).time }} - {{ formatDateTime(item.end_time).time }}
                                                        </span>
                                                    </div>
                                                    <div>
                                                        Par <b>{{ item.user_name }}</b>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span :class="bookingStatuses[item.status]['class']" class="badge badge-pill text-xs py-1 px-2">
                                                        {{ bookingStatuses[item.status]['label'] }}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span class="d-block">{{ paymentMethods[item.payment_method] }}</span>
                                                    <b class="d-block text-sm">{{ item.amount }}<sup>DT</sup></b>
                                                    <span v-if="item.payment_method == 'online'" class="d-block text-muted text-xs">Avance: <b>{{ item.paid_amount }}<sup>DT</sup></b></span>
                                                    <span v-if="item.discount_amount > 0" class="d-block text-muted text-xs">Remise: <b>{{ item.discount_amount }}<sup>DT</sup></b> ({{ item.voucher_code }})</span>
                                                </td>
                                                <td style="min-width: 100px;">
                                                    {{ formatDateTime(item.created_at).date }}
                                                    <span class="d-block text-muted">à {{ formatDateTime(item.created_at).time }}</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <!-- PAGINATION -->
                                <nav class="mt-3">
                                    <ul class="pagination justify-content-center">
                                        <li class="page-item" :class="{ disabled: currentBookingsPage === 1 }">
                                            <button class="page-link text-dark" @click="goToPage(currentBookingsPage - 1, 'bookings')">
                                                <span class="material-symbols-outlined text-sm">arrow_back</span>
                                            </button>
                                        </li>
                                        <li class="page-item">
                                            <select class="page-link text-dark text-xs h-100" v-model="currentBookingsPage" @change="goToPage(Number(currentBookingsPage), 'bookings')">
                                                <option v-for="page in totalBookingsPages" :key="page" :value="page">
                                                    Page {{ page }}
                                                </option>
                                            </select>
                                        </li>
                                        <li class="page-item" :class="{ disabled: currentBookingsPage === totalBookingsPages }">
                                            <button class="page-link text-dark" @click="goToPage(currentBookingsPage + 1, 'bookings')">
                                                <span class="material-symbols-outlined text-sm">arrow_forward</span>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                            <div v-else class="mt-5 text-sm text-center">
                                Aucune correspondance précise
                            </div>
                        </div>
                        <div v-else-if="currentModalView == 'settlementUpdate'">

                            <div class="row w-100 mx-auto mt-2">
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label>Méthode de Paie.</label>
                                        <select class="form-control custom-select text-sm" v-model="selectedSettlement.payment_method" required="">
                                            <option value="cash">Espèces</option>
                                            <option value="cheque">Chéque</option>
                                            <option value="bank_transfer">Virement Bancaire</option>
                                            <option value="others">Autre</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label>Référence de Paie.</label>
                                        <textarea class="form-control text-sm" rows="3" v-model="selectedSettlement.payment_reference">
                                        </textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer" v-if="currentUser.role !== 'owner'">
                    <button type="button" v-if="currentModalView == 'bookings'" @click="currentModalView='settlementUpdate'" class="btn btn-sm btn-outline-info" :disabled="selectedSettlement.status == 'paid'">Marquer comme payé</button>
                    <button type="button" v-if="currentModalView == 'settlementUpdate'" @click="currentModalView='bookings'" class="btn btn-sm btn-outline-secondary">Retour</button>
                    <button type="button" v-if="currentModalView == 'settlementUpdate'" class="btn btn-sm btn-primary" @click="confirmPayment()">Confirmer Paie.</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import VendorSidebar from "@/components/Vendors/Partials/Sidebar";
import { api } from "@/store";
import vSelect from "vue-select";

import defaultLogoPath from '@/assets/img/photo.png'

export default {
    components: {
        "vendor-sidebar": VendorSidebar,
        "v-select": vSelect,
    },
    computed: {
        filtersApplied() {
            return (
                (this.currentUser.role === 'admin' && this.selectedEstablishment !== 'all') ||
                this.selectedPaymentStatus !== 'all'
            )
        },
        cardSourceSettlements() {
            return this.filtersApplied ? this.filteredSettlements : this.settlements
        },
        currentUser() {
            return this.$store.getters.currentUser;
        },
        countReservations() {
            return this.cardSourceSettlements.reduce((sum, s) => sum + s.count_bookings, 0)
        },
        unpaidSettlements() {
            return this.cardSourceSettlements.filter(s => s.status !== 'paid').length
        },
        ownerToPlatform() {
            return this.cardSourceSettlements.filter(s => s.direction === 'owner_to_platform' && s.status !== 'paid').reduce((sum, s) => sum + s.total_to_pay, 0).toFixed(3)
        },
        platformToOwner() {
            return this.cardSourceSettlements.filter(s => s.direction === 'platform_to_owner' && s.status !== 'paid').reduce((sum, s) => sum + s.total_to_pay, 0).toFixed(3)
        },
        totalPages() {
            return Math.ceil(this.filteredSettlements.length / this.perPage);
        },
        filteredEstablishments() {
            const uniqueEstablishments = this.settlements
                .map(s => ({ ...s.establishment, id: String(s.establishment.id) }))
                .filter((est, index, self) => self.findIndex(e => e.id === est.id) === index)
                .sort((a, b) => a.business_name.localeCompare(b.business_name))

            return [{ id: 'all', business_name: 'Tous les établissements' }, ...uniqueEstablishments]
        },
        filteredSettlements() {
            let filtered = this.settlements
            
            // Filter by establishment (admin only)
            if (this.currentUser.role === 'admin' && this.selectedEstablishment !== 'all') {
                filtered = filtered.filter(s => String(s.establishment.id) === this.selectedEstablishment)
            }
            
            // Filter by payment status
            if (this.selectedPaymentStatus === 'all') {
                return filtered
            }
            if (this.selectedPaymentStatus === 'unpaid') {
                return filtered.filter(s => s.status === 'pending' || s.status === 'unpaid')
            }
            return filtered.filter(s => s.status === this.selectedPaymentStatus)
        },
        paginatedData() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.filteredSettlements.slice(start, start + this.perPage);
        },
        totalBookingsPages() {
            let filteredCount = this.bookings.length
            if (this.selectedFacility !== 'all') {
                filteredCount = this.bookings.filter(booking => booking.slot.facility.id === this.selectedFacility).length
            }
            return Math.ceil(filteredCount / this.bookingsPerPage);
        },
        paginatedBookingsData() {
            const start = (this.currentBookingsPage - 1) * this.bookingsPerPage;
            let bookings = this.bookings.sort((a, b) => a.start_time.localeCompare(b.start_time))
            if (this.selectedFacility !== 'all') {
                bookings = bookings.filter(booking => booking.slot.facility.id === this.selectedFacility)
            }
            return bookings.slice(start, start + this.bookingsPerPage);
        },
        totalBookings() {
            return this.bookings.reduce((sum, s) => sum + s.amount, 0).toFixed(3)
        },
        cardsDisplay() {
            return [
                { ...this.cards[0], aggregation: this.countReservations },
                { ...this.cards[1], aggregation: this.unpaidSettlements },
                { ...this.cards[2], aggregation: this.ownerToPlatform },
                { ...this.cards[3], aggregation: this.platformToOwner },
            ]
        },
    },
    data() {
        return {
            activeTab: 'upcoming',
            facilities: [],
            selectedFacility: 'all',
            selectedPaymentStatus: 'all',
            selectedEstablishment: 'all',
            cards: [
                { label: 'Réservations', color: 'text-success', aggregation: 0, icon: 'event' },
                { label: 'Réglements non payés', color: 'text-danger', aggregation: 0, icon: 'money_off' },
                { label: 'À payer pour 6v6', color: 'text-primary', aggregation: 0, icon: 'payments' },
                { label: 'À payer pour Prop.', color: 'text-primary', aggregation: 0, icon: 'payments' }
            ],
            settlementCards: [
                { label: 'Réservations', color: 'text-success', aggregation: 0, icon: 'event' },
                { label: 'Total', color: 'text-info', aggregation: 0, icon: 'payments' },
                { label: 'À payer pour', color: 'text-primary', aggregation: 0, icon: 'payments' },
            ],
            settlements: [],
            selectedSettlement: {},
            paymentMethods: {
                'cash': 'Espèces',
                'online': 'En ligne'
            },
            currentModalView: 'bookings',
            bookings: [],
            bookingStatuses: {
                'expired': {'label': 'expirée', 'class': 'bg-danger-light'},
                'payment failed': {'label': 'paiement échoué', 'class': 'bg-danger-light'},
                'aborted': {'label': 'abandonnée', 'class': 'bg-danger-light'},
                'cancelled': {'label': 'annulée', 'class': 'bg-danger text-white font-weight-bolder'},
                'rejected': {'label': 'rejeté', 'class': 'bg-danger text-white font-weight-bolder'},
                'pending': {'label': 'en cours', 'class': 'bg-warning-light'},
                'pending approval': {'label': 'attente confirmation', 'class': 'bg-warning-light'},
                'awaiting payment': {'label': 'attente paiement', 'class': 'bg-warning-light'},
                'confirmed': {'label': 'confirmée', 'class': 'bg-success-light'},
                'completed': {'label': 'complétée', 'class': 'bg-success-light'},
                'ongoing': {'label': 'en jeu', 'class': 'bg-primary-light'},
                'played': {'label': 'jouée', 'class': 'bg-success-light'}
            },
            settlementStatuses: {
                'paid': {'label': 'payé', 'class': 'bg-success-light'},
                'partially_paid': {'label': 'paie. partiel', 'class': 'bg-warning-light'},
                // 'pending': {'label': 'paie. en attente', 'class': 'bg-warning text-white'},
                'pending': {'label': 'non payé', 'class': 'bg-danger text-white font-weight-bolder'},
                'unpaid': {'label': 'non payé', 'class': 'bg-danger text-white font-weight-bolder'},
            },
            entities: {
                'platform': '6v6',
                'owner': 'Propriétaire',
            },
            currentPage: 1,     // selected page
            perPage: 5,         // items per page
            currentBookingsPage: 1,     // selected page
            bookingsPerPage: 5,         // items per page
        };
    },
    mounted() {
        this.getSettlements()
    },
    methods: {
        getSettlements() {
            this.currentPage = 1
            api.get("/private/settlements")
                .then(response => {
                    const result = response.data;
                    this.settlements = result
                    this.currentPage = 1;
                });
        },
        confirmPayment() {
            api.post(`/private/settlements/${this.selectedSettlement.id}/confirm_payment`, {
                payment_method: this.selectedSettlement.payment_method,
                payment_reference: this.selectedSettlement.payment_reference,
            })
                .then((response) => {
                    this.getSettlements()
                    $('#bookingsModal').modal('hide');
                });
        },
        openBookingsModal(settlement) {
            this.currentModalView = 'bookings'
            this.selectedSettlement = settlement
            this.selectedFacility = 'all'
            this.currentBookingsPage = 1
            this.bookings = settlement.bookings.map(booking => {
                    booking.status = 'played'
                    return {
                        ...booking
                    }
                })
            
            this.updateSettlementCards()
        },
        updateSettlementCards() {
            let filteredBookings = this.bookings
            if (this.selectedFacility !== 'all') {
                filteredBookings = this.bookings.filter(booking => booking.slot.facility.id === this.selectedFacility)
            }
            const countBookings = filteredBookings.length
            const facilitiesMap = new Map()
            this.bookings.forEach(booking => {
                if (booking.slot && booking.slot.facility) {
                    const facility = booking.slot.facility
                    if (!facilitiesMap.has(facility.id)) {
                        facilitiesMap.set(facility.id, facility)
                    }
                }
            })
            this.facilities = Array.from(facilitiesMap.values())
            
            const totalBookings = filteredBookings.reduce((sum, b) => sum + b.amount, 0).toFixed(3)
            
            this.settlementCards[0]['aggregation'] = countBookings
            this.settlementCards[1]['aggregation'] = totalBookings
            this.settlementCards[2]['aggregation'] = this.selectedSettlement.total_to_pay.toFixed(3)
            this.settlementCards[2]['label'] = `À payer pour ${this.selectedSettlement.direction == 'owner_to_platform' ? '6v6' : 'prop.'}`
        },
        now() {
            return moment().format('YYYY-MM-DDTHH:mm:ss')
        },
        formatDateTime(datetimeString) {
            if (!datetimeString) return "";
            const date = new Date(datetimeString);
            const formattedDate = date.toISOString().split("T")[0];
            let displayDate = date.toLocaleDateString("fr-FR", { weekday: "short", year: "numeric", month: "short", day: "numeric" }).split("T")[0];
            displayDate = displayDate.split(" ") .map(word => word.charAt(0).toUpperCase() + word.slice(1)) .join(" ");
            // Extract local hours and minutes
            const hours = date.getHours().toString().padStart(2, "0");
            const minutes = date.getMinutes().toString().padStart(2, "0");
            let date_obj = {
                date: displayDate,
                time: `${hours}:${minutes}`,
                datetime: formattedDate + ` ${hours}:${minutes}`,
            };
            return date_obj;
        },
        addToDate(datetimeString, count, unit) {
            const datetime = moment(datetimeString).add(count, unit)
            return datetime.format('YYYY-MM-DDTHH:mm:ss')
        },
        notStartedYet(booking) {
            return this.formatDateTime(booking.start_time).datetime > moment().format('YYYY-MM-DD HH:mm')
        },
        goToPage(page, data='settlements') {
            if (data == 'settlements' && page >= 1 && page <= this.totalPages) {
                this.currentPage = page;
            }
            if (data == 'bookings' && page >= 1 && page <= this.totalBookingsPages) {
                this.currentBookingsPage = page;
            }
        },
    },
    watch: {
        'selectedPaymentStatus': function() {
            this.currentPage = 1
        },
        'selectedEstablishment': function() {
            this.currentPage = 1
        },
        'selectedSettlement': function(newValue) {
            this.bookings = newValue.bookings
        },
        'selectedFacility': function() {
            this.currentBookingsPage = 1
        }
    }
}
</script>

<style scoped>
.concatenated-select {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  margin-top: -1px;
}

.filter-label {
  font-size: 0.75rem;
}
</style>